/**
 * Resize Chosen.
 */
window.resizeChosen = function() {
    setTimeout(function() {
        $(".chosen-container").each(function() {
            $(this).attr('style', 'width: 100%');
        });
    }, 1100);
};

/**
 * Prevent chosen dropdowns from being clipped by ancestor overflow rules.
 * Scroll containers (overflow: auto/scroll) are never altered — changing them
 * to overflow:visible would break the flex layout. Instead we detect whether
 * the drop would overflow those containers and flip it upward.
 */
(function() {
    const DATA_KEY = 'chosenOverflowAncestors';

    const isClipping = function(value) {
        return value === 'hidden' || value === 'clip';
    };

    const isScrolling = function(value) {
        return value === 'auto' || value === 'scroll';
    };

    const openDropdown = function(select) {
        const $select = $(select);
        const ancestors = [];
        let scrollBoundary = window.innerHeight;

        $select.parents().each(function() {
            const computed = window.getComputedStyle(this);
            const overflow  = computed.overflow;
            const overflowX = computed.overflowX;
            const overflowY = computed.overflowY;

            // Capture the nearest scroll container's visible bottom as the flip boundary.
            if (scrollBoundary === window.innerHeight && (isScrolling(overflowY) || isScrolling(overflow))) {
                scrollBoundary = this.getBoundingClientRect().bottom;
            }

            // Never alter scroll containers — doing so disrupts the flex layout.
            if (isScrolling(overflowY) || isScrolling(overflow)) {
                return;
            }

            // For pure clip/hidden ancestors, temporarily allow overflow so the drop is visible.
            if (!isClipping(overflow) && !isClipping(overflowX) && !isClipping(overflowY)) {
                return;
            }

            ancestors.push({
                element: this,
                overflow: this.style.overflow,
                overflowX: this.style.overflowX,
                overflowY: this.style.overflowY,
            });

            this.style.overflow  = 'visible';
            this.style.overflowX = 'visible';
            this.style.overflowY = 'visible';
        });

        $select.data(DATA_KEY, ancestors);

        // Flip the drop upward if it would overflow the scroll container.
        const $container = $select.next('.chosen-container');
        if ($container.length) {
            const rect       = $container[0].getBoundingClientRect();
            const dropHeight = $container.find('.chosen-drop').outerHeight() || 250;
            if (rect.bottom + dropHeight > scrollBoundary) {
                $container.addClass('chosen-drop-up');
            }
        }
    };

    const closeDropdown = function(select) {
        const $select   = $(select);
        const ancestors = $select.data(DATA_KEY) || [];

        ancestors.forEach(function(entry) {
            entry.element.style.overflow  = entry.overflow  || '';
            entry.element.style.overflowX = entry.overflowX || '';
            entry.element.style.overflowY = entry.overflowY || '';
        });

        $select.removeData(DATA_KEY);
        $select.next('.chosen-container').removeClass('chosen-drop-up');
    };

    $(document).on('chosen:showing_dropdown', 'select', function() {
        openDropdown(this);
    });

    $(document).on('chosen:hiding_dropdown', 'select', function() {
        closeDropdown(this);
    });
})();
